/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentTag,
  CreateContentTagRequest,
  ErrorResponse,
} from '../models/index';
import {
    ContentTagFromJSON,
    ContentTagToJSON,
    CreateContentTagRequestFromJSON,
    CreateContentTagRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface CreateTagRequest {
    createContentTagRequest: CreateContentTagRequest;
}

export interface DeleteTagRequest {
    id: string;
}

export interface GetAllTagsRequest {
    organizationId?: string;
}

export interface GetTagByIdRequest {
    id: string;
}

export interface UpdateTagRequest {
    id: string;
    createContentTagRequest: CreateContentTagRequest;
}

/**
 * 
 */
export class TagsApi extends runtime.BaseAPI {

    /**
     * Create a new tag
     * Create a new tag
     */
    async createTagRaw(requestParameters: CreateTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentTag>> {
        if (requestParameters['createContentTagRequest'] == null) {
            throw new runtime.RequiredError(
                'createContentTagRequest',
                'Required parameter "createContentTagRequest" was null or undefined when calling createTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContentTagRequestToJSON(requestParameters['createContentTagRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentTagFromJSON(jsonValue));
    }

    /**
     * Create a new tag
     * Create a new tag
     */
    async createTag(requestParameters: CreateTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentTag> {
        const response = await this.createTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a tag
     * Delete tag
     */
    async deleteTagRaw(requestParameters: DeleteTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/tags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a tag
     * Delete tag
     */
    async deleteTag(requestParameters: DeleteTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTagRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve a list of all tags
     * Get all tags
     */
    async getAllTagsRaw(requestParameters: GetAllTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContentTag>>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContentTagFromJSON));
    }

    /**
     * Retrieve a list of all tags
     * Get all tags
     */
    async getAllTags(requestParameters: GetAllTagsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContentTag>> {
        const response = await this.getAllTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a tag by its ID
     * Get tag by ID
     */
    async getTagByIdRaw(requestParameters: GetTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentTag>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTagById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/tags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentTagFromJSON(jsonValue));
    }

    /**
     * Retrieve a tag by its ID
     * Get tag by ID
     */
    async getTagById(requestParameters: GetTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentTag> {
        const response = await this.getTagByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing tag
     * Update tag
     */
    async updateTagRaw(requestParameters: UpdateTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentTag>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTag().'
            );
        }

        if (requestParameters['createContentTagRequest'] == null) {
            throw new runtime.RequiredError(
                'createContentTagRequest',
                'Required parameter "createContentTagRequest" was null or undefined when calling updateTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/tags/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateContentTagRequestToJSON(requestParameters['createContentTagRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentTagFromJSON(jsonValue));
    }

    /**
     * Update an existing tag
     * Update tag
     */
    async updateTag(requestParameters: UpdateTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentTag> {
        const response = await this.updateTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
